/* eslint-disable */
// This file is automatically generated and should not be edited directly.
// Please edit the corresponding SVG file

import React from 'react';

const Four = (props: any) => (
<svg {...props} xmlns="http://www.w3.org/2000/svg" width="58" height="72" viewBox="0 0 58 72" fill="none">
<path d="M24.9748 58.3526H1.1748L4.7748 41.3526L43.1748 0.952637H56.1748L47.5748 41.3526H55.9748L52.3748 58.3526H43.9748L41.3748 70.7526H22.3748L24.9748 58.3526ZM30.7748 41.3526L33.3748 29.3526L23.4748 41.3526H30.7748Z" fill="white"/>
<path fillRule="evenodd" clipRule="evenodd" d="M24.9752 58.3524H1.17518L4.77518 41.3524L43.1752 0.952381H56.1752L47.5752 41.3524H55.9752L52.3752 58.3524H43.9752L41.3752 70.7524H22.3752L24.9752 58.3524ZM44.7486 59.3048L42.1486 71.7048H21.2024L23.8024 59.3048H0L3.89928 40.8915L42.7665 0H57.3516L48.7516 40.4H57.1504L53.147 59.3048H44.7486ZM33.3752 29.3524L23.4752 41.3524H30.7752L33.3752 29.3524ZM31.6139 32.9838L30.0071 40.4H25.4956L31.6139 32.9838Z" fill="#A78952"/>
</svg>);

export default Four;